export default __webpack_public_path__ + "static/media/pichia06-5.d25d5260.jpg";